import NavbarItem from 'app/layouts/navbar/navbar-item.model';

export const EntityNavbarItems: NavbarItem[] = [
  {
    name: 'StringValue',
    route: '/string-value',
    translationKey: 'global.menu.entities.stringValue',
  },
  {
    name: 'UidValue',
    route: '/uid-value',
    translationKey: 'global.menu.entities.uidValue',
  },
  {
    name: 'Trip',
    route: '/trip',
    translationKey: 'global.menu.entities.trip',
  },
  {
    name: 'Parcel',
    route: '/parcel',
    translationKey: 'global.menu.entities.parcel',
  },
  {
    name: 'Media',
    route: '/media',
    translationKey: 'global.menu.entities.media',
  },
  {
    name: 'ParcelNumber',
    route: '/parcel-number',
    translationKey: 'global.menu.entities.parcelNumber',
  },
  {
    name: 'WeightUnit',
    route: '/weight-unit',
    translationKey: 'global.menu.entities.weightUnit',
  },
  {
    name: 'Currency',
    route: '/currency',
    translationKey: 'global.menu.entities.currency',
  },
  {
    name: 'Language',
    route: '/language',
    translationKey: 'global.menu.entities.language',
  },
  {
    name: 'Category',
    route: '/category',
    translationKey: 'global.menu.entities.category',
  },
  {
    name: 'CategoryI18n',
    route: '/category-i-18-n',
    translationKey: 'global.menu.entities.categoryI18n',
  },
  {
    name: 'ResidenceAddress',
    route: '/residence-address',
    translationKey: 'global.menu.entities.residenceAddress',
  },
  {
    name: 'Address',
    route: '/address',
    translationKey: 'global.menu.entities.address',
  },
  {
    name: 'Notification',
    route: '/notification',
    translationKey: 'global.menu.entities.notification',
  },
  {
    name: 'Chat',
    route: '/chat',
    translationKey: 'global.menu.entities.chat',
  },
  {
    name: 'Message',
    route: '/message',
    translationKey: 'global.menu.entities.message',
  },
  {
    name: 'UserAccount',
    route: '/user-account',
    translationKey: 'global.menu.entities.userAccount',
  },
  {
    name: 'Booking',
    route: '/booking',
    translationKey: 'global.menu.entities.booking',
  },
  {
    name: 'FullIndex',
    route: '/full-index',
    translationKey: 'global.menu.entities.fullIndex',
  },
  {
    name: 'BookingStatusChange',
    route: '/booking-status-change',
    translationKey: 'global.menu.entities.bookingStatusChange',
  },
  {
    name: 'MeanOfTransport',
    route: '/mean-of-transport',
    translationKey: 'global.menu.entities.meanOfTransport',
  },
  {
    name: 'Email',
    route: '/email',
    translationKey: 'global.menu.entities.email',
  },
];
